/**
 * Application constants
 */

export const APP_NAME = "Template App";

// Route constants are now in @app/router/routes.constants.ts
// Re-export for backward compatibility

export const QUERY_STALE_TIME = {
  SHORT: 1 * 60 * 1000, // 1 minute
  MEDIUM: 5 * 60 * 1000, // 5 minutes
  LONG: 30 * 60 * 1000, // 30 minutes
} as const;

export const QUERY_CACHE_TIME = 1000 * 60 * 60 * 24; // 24 hours

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
} as const;
